import React from "react";
import { Button, Form, Input, Typography } from "antd";
import { MailOutlined } from "@ant-design/icons";
import { forgotPassword } from "../../services/user.service";
import { useMutation } from "react-query";
import { AlertService } from "../../services/alert.service";
import { useNavigate } from "react-router";

export default function Forgot() {
  const [formForgotPassword] = Form.useForm();

  const navigate = useNavigate();

  const { Title, Text, Link } = Typography;

  const { mutate: forgot, isLoading: forgotLoading } = useMutation(
    forgotPassword,
    {
      onSuccess: () => {
        AlertService.sendAlert([
          {
            text: `
                Enviamos um e-mail para o endereço fornecido com instruções sobre como redefinir a password, que deverá chegar em breve.
                Caso não tenha recebido, verifique sua caixa de entrada e spam ou solicite um novo e-mail.
              `,
            nextPage: true,
          },
        ]);

        navigate("/");
      },
    }
  );

  const onFinish = async (values: any) => {
    formForgotPassword
      .validateFields()
      .then((values) => {
        values.email = values.email.trim();
        forgot(values);
      })
      .catch(() =>
        AlertService.sendAlert([
          { text: "Campo(s) com preenchimento inválido", type: "error" },
        ])
      );
  };

  return (
    <div style={{ padding: "0 20px" }}>
      <div style={{ textAlign: "center", marginBottom: 40 }}>
        <Title level={2} style={{ marginBottom: 10 }}>
          Redefinir senha
        </Title>
        <Text type="secondary" style={{ fontSize: 16 }}>
          Insira o e-mail associado à sua conta para receber instruções
        </Text>
      </div>

      <Form
        onFinish={onFinish}
        form={formForgotPassword}
        layout="vertical"
        size="large"
        requiredMark={false}
      >
        <Form.Item
          name="email"
          label="E-mail"
          rules={[
            { required: true, message: "Por favor insira um email válido!" },
            { type: "email", message: "Formato de email inválido" },
          ]}
        >
          <Input
            prefix={<MailOutlined className="site-form-item-icon" />}
            placeholder="seu@email.com"
            type="email"
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={forgotLoading}
            size="large"
            block
            style={{ height: 45, fontSize: 16, marginTop: 10 }}
          >
            Enviar instruções
          </Button>
        </Form.Item>

        <div style={{ textAlign: "center", marginTop: 20 }}>
          <Link onClick={() => navigate("/")} style={{ fontWeight: "bold" }}>
            Voltar para login
          </Link>
        </div>
      </Form>
    </div>
  );
}
